import { LOANREQUEST_STATUSES, SUB_STATUS_INITIAL, TEMPLATE_TYPES } from 'cpool-constants';
import { divisionId, schemaCanceled, schemaStatus } from 'cpool-schemas';
import { schemaApproved } from 'cpool-schemas/src/LoanRequest/status/discriminatedUnions/approved';
import { schemaInitial } from 'cpool-schemas/src/LoanRequest/status/discriminatedUnions/initial';
import { schemaInProgress } from 'cpool-schemas/src/LoanRequest/status/discriminatedUnions/inProgress';
import { schemaOfferAtBank } from 'cpool-schemas/src/LoanRequest/status/discriminatedUnions/offerAtBank';
import { schemaOfferAtCustomer } from 'cpool-schemas/src/LoanRequest/status/discriminatedUnions/offerAtCustomer';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class Template_DivisionMailCreated extends _Event {
    constructor(payload: EventSchema<Template_DivisionMailCreated>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            active: z.boolean().nullish(),
            // unfortunately we cannot use the schemaStatus directly here, because it is a discriminated union
            assignedStatus: z
                .discriminatedUnion(schemaStatus.discriminator, [
                    schemaInitial.pick({ status: true, subStatus: true }),
                    schemaInProgress.pick({ status: true, subStatus: true }),
                    schemaOfferAtCustomer.pick({ status: true, subStatus: true }),
                    schemaOfferAtBank.pick({ status: true, subStatus: true }),
                    schemaApproved.pick({ status: true, subStatus: true }),
                    schemaCanceled.pick({ status: true, statusReason: true, subStatus: true }),
                ])
                .nullable(),
            divisionId,
            mailContent: z.string().min(1),
            mailHTMLContent: z.string().min(1),
            name: z.string().min(1),
            priority: z.optional(z.number().int().default(0)),
            subject: z.string().min(1),
            technicalDescription: z.string().min(1).nullish(),
            type: z.literal(TEMPLATE_TYPES.DIVISION_MAIL),
        });
    }

    static example(): EventSchema<Template_DivisionMailCreated> {
        return {
            assignedStatus: {
                status: LOANREQUEST_STATUSES.INITIAL,
                subStatus: SUB_STATUS_INITIAL.FIRST_ATTEMPT,
            },
            divisionId: 'AB3CD6',
            mailContent: 'This is the mail content',
            mailHTMLContent: '<html><body>This is the mail HTML content</body></html>',
            name: 'Mail Template',
            priority: 0,
            subject: 'Mail Template Subject',
            type: TEMPLATE_TYPES.DIVISION_MAIL,
        };
    }
}
